/** Split a scene clip into the timed stills stored on visual_beats. */

export function visualBeatsWithImages(scene) {
  const raw = scene?.visual_beats || scene?.visualBeats || [];
  if (!Array.isArray(raw)) return [];
  return raw
    .filter((beat) => beat && String(beat.image_url || beat.imageUrl || '').trim())
    .map((beat) => {
      const start = Number(beat.start) || 0;
      const end = Number(beat.end) || start;
      const duration = Number(beat.duration) > 0 ? Number(beat.duration) : Math.max(0, end - start);
      return {
        ...beat,
        imageUrl: String(beat.image_url || beat.imageUrl).trim(),
        start,
        end: start + duration,
        duration,
        sentence: String(beat.sentence || '').trim(),
      };
    })
    .filter((beat) => beat.duration > 0.05)
    .sort((a, b) => a.start - b.start);
}

export function expandTrackWithVisualBeats(track, scenes) {
  const sceneById = Object.fromEntries(
    (scenes || []).filter((scene) => scene?.id).map((scene) => [String(scene.id), scene]),
  );
  const expanded = new Set();
  const out = [];
  (track || []).forEach((clip) => {
    if (!clip || clip.isBookend) {
      out.push(clip);
      return;
    }
    if (clip.visualBeat != null) {
      out.push(clip);
      const sid = String(clip.parentSceneId || clip.sceneId || '');
      if (sid) expanded.add(sid);
      return;
    }
    const sid = String(clip.sceneId || clip.id || '');
    const scene = sceneById[sid];
    const beats = scene ? visualBeatsWithImages(scene) : [];
    const hasVideo = Boolean(scene?.video_url || scene?.videoUrl || clip.videoUrl);
    if (!scene || beats.length < 2 || expanded.has(String(scene.id)) || hasVideo) {
      out.push(clip);
      return;
    }
    const base = Number(clip.startTime) || 0;
    beats.forEach((beat, index) => {
      out.push({
        ...clip,
        id: `${scene.id}__beat${index}`,
        sceneId: scene.id,
        parentSceneId: scene.id,
        visualBeat: index,
        name: `${clip.name || 'Segment'} · ${index + 1}`,
        startTime: Math.round((base + beat.start) * 1000) / 1000,
        duration: beat.duration,
        playbackDuration: beat.duration,
        timelineSlotDuration: beat.duration,
        trimStart: 0,
        trimEnd: beat.duration,
        imageUrl: beat.imageUrl,
        videoUrl: null,
        video_s3_url: null,
        video_local_url: null,
        muted: true,
        sceneText: beat.sentence || clip.sceneText || '',
        narrationText: beat.sentence || clip.narrationText || '',
      });
    });
    expanded.add(String(scene.id));
  });
  return out;
}
